var React = require('react');

function Profile (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#111827","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"},[React.createElement("path",{"d":"m12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10z","key":0}),React.createElement("path",{"d":"m4.27148 18.346s2.229-2.846 7.72902-2.846c5.5 0 7.73 2.846 7.73 2.846m-7.73-6.346c.7956 0 1.5587-.3161 2.1213-.8787s.8787-1.32565.8787-2.1213-.3161-1.55871-.8787-2.12132-1.3257-.87868-2.1213-.87868c-.7957 0-1.5587.31607-2.12134.87868-.56261.56261-.87868 1.32567-.87868 2.12132s.31607 1.5587.87868 2.1213c.56264.5626 1.32564.8787 2.12134.8787z","key":1})]));
}

Profile.defaultProps = {"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Profile;

Profile.default = Profile;
